import { default as crud, loadCrud } from './modules/crud';
import { default as dashboard, loadDashboard } from './modules/dashboard';
import { default as mediaManager, loadMediaManager } from './modules/mediaManager';

import en from '../lang/index-en.js';

export default {
  apiRoot: process.env.VUE_APP_API_ROOT,
  endpoints: {
    signup: '/signup',
    verify: '/verify',
  },
  resetPassword: true,
  adminEmail: 'baum@ax2.ca',
  modules: {
    crud,
    dashboard,
    mediaManager,
  },
  singleLocale: true,
  i18n: {
    fallbackLocale: 'en',
    messages: {
      en,
    },
  },
  userRights: {
    1: 'read',
    2: 'edit',
    4: 'add',
    8: 'delete',
    16: 'export',
  },
};

export function loadModules (context) {
  loadCrud(context);
  loadDashboard(context);
  loadMediaManager(context);
}
